import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { AnnouncementBanner } from '../Home/AnnouncementBanner';
interface LayoutProps {
  children: React.ReactNode;
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
}
export const Layout = ({
  children,
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen" data-id="element-827" data-mp="19cvr8pabftbd">
      <AnnouncementBanner data-id="element-828" data-mp="1df8vtadbtl6k" />
      <div className="h-[32px]" data-id="element-829" data-mp="1dehbwwt3dbw4"></div>
      <Header openRegistrationForm={openRegistrationForm} openPaymentForm={openPaymentForm} data-id="element-830" data-mp="1ddo3zsiecgce" />
      <main className="flex-grow pt-[76px]" data-id="element-831" data-mp="1iev7vghf4vds">{children}</main>
      <Footer openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} data-id="element-832" data-mp="1ndyf97kvfdox" />
    </div>;
};